<template>
  <v-container fluid>
    <v-container fluid class="app-container">

      <v-stepper v-model="currentStep">
        <v-stepper-header>
          <v-stepper-step
            :complete="currentStep > 1"
            step="1"
          >
            Usuário
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            step="2"
            :complete="currentStep > 2"
          >Empresa
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            step="3"
            :complete="currentStep > 3"
          >
            Locais de atuação
          </v-stepper-step>

        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">

            <px-criar-conta-nova-empresa-usuario :empresa="empresa"
                                                 @ready="next"/>

          </v-stepper-content>

          <v-stepper-content step="2">

            <px-criar-conta-nova-empresa-step-empresa @ready="next"
                                                      @back="previous"
                                                      :empresa="empresa.transportadora"/>

          </v-stepper-content>

          <v-stepper-content step="3">

            <div v-if="currentStep === 3">
              <px-criar-conta-locais-atuacao :empresa="empresa.transportadora"
                                             :loading-form="loading"
                                             @back="previous"
                                             @ready="enviar"/>
            </div>

          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-container>
  </v-container>
</template>

<script>
import { cloneDeep } from 'lodash';
import { onlyNumbers } from '@/utils/regex-utils';
import TransportadorService from './transportador-service';
import CriarContaNovaEmpresaStepEmpresa from './empresa/CriarContaNovaEmpresaStepEmpresa.vue';
import CriarContaNovaEmpresaUsuario from './usuario/CriarContaNovaEmpresaUsuario.vue';
import CriarContaLocaisAtuacao from './locais-atuacao/CriarContaLocaisAtuacao.vue';

export default {
  data() {
    return {
      loading: false,
      currentStep: 1,
      empresa: {
        usuario: {
          nome: null,
          cpf: null,
          email: null,
          telefone: null,
          password: null,
          matchPassword: null,
        },
        transportadora: {
          pessoa: {
            cnpj: null,
            regimeTributario: null,
            nome: '',
            nomeReceita: '',
            telefone: '',
            email: '',
          },
          site: '',
          locaisColeta: [],
          endereco: {
            cep: null,
            rua: null,
            numero: null,
            bairro: null,
            estado: null,
            municipio: null,
          },
        },
      },
    };
  },
  methods: {
    next() {
      this.currentStep += 1;
    },
    previous() {
      this.currentStep -= 1;
    },
    enviar() {
      const transportadora = this.buildCadastro();
      this.loading = true;
      TransportadorService.criar(transportadora)
        .then(() => {
          this.$toast('Seu cadastro foi efetuado', { color: 'success' });
          return this.$router.push({ name: 'login' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildCadastro() {
      const transportador = cloneDeep(this.empresa);

      transportador.transportadora.endereco.cep = onlyNumbers(
        transportador.transportadora.endereco.cep,
      );
      transportador.transportadora.pessoa.cnpj = onlyNumbers(
        transportador.transportadora.pessoa.cnpj,
      );
      transportador.usuario.telefone = onlyNumbers(transportador.usuario.telefone);
      transportador.usuario.cpf = onlyNumbers(transportador.usuario.cpf);

      transportador.transportadora.locaisColeta = transportador.transportadora.locaisColeta
        .map((local) => ({
          estado: {
            id: local.id,
          },
        }));

      return transportador;
    },
  },
  components: {
    pxCriarContaNovaEmpresaStepEmpresa: CriarContaNovaEmpresaStepEmpresa,
    pxCriarContaNovaEmpresaUsuario: CriarContaNovaEmpresaUsuario,
    pxCriarContaLocaisAtuacao: CriarContaLocaisAtuacao,
  },
  created() {
  },
};
</script>
